// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import * as filters from './filters';
import Toasted from 'vue-toasted';
import flatpickr from 'flatpickr';
import flatpickrVue from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Serbian } from 'flatpickr/dist/l10n/sr';

Vue.config.productionTip = false;

for (const key in filters)
	Vue.filter(key, filters[key]);

Vue.use(Toasted, {
	position: 'bottom-left',
	duration: 4000,
	theme: 'primary',
	className: 'toast',
	containerClass: 'toast-container'
});

flatpickr.localize(Serbian);

flatpickr.setDefaults({
	dateFormat: 'Y-m-d',
	altFormat: 'd.m.Y.',
	altInput: true
});

Vue.use(flatpickrVue);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js